import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ErrorService } from '../../../services/error.service';
import { UtilService } from '../../../services/util.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { SbDateTime } from '../../../services/api/api-date-time';
import { DateTime } from 'luxon';
import { PermissionService } from '../../../services/permission.service';

@Component({
  selector: 'sb-page-statistic-overview',
  templateUrl: './statistic-overview.component.html',
  styleUrls: ['./statistic-overview.component.scss'],
  animations: [
    trigger('slideDownUp', [
      transition(':enter', [style({ transform: 'translateY(100%)' }), animate('500ms', style({ transform: 'translateY(0%)' }))]),
      transition(':leave', [style({ transform: 'translateY(0)' }), animate('500ms', style({ transform: 'translateY(-100%)' }))]),
    ]),
  ],
  standalone: false,
})
export class StatisticOverviewComponent implements OnInit {
  dateTime: SbDateTime;

  constructor(
    public errorHandler: ErrorService,
    public translate: TranslateService,
    public util: UtilService,
    public permissionService: PermissionService
  ) {
    this.dateTime = new SbDateTime(DateTime.local());
  }

  ngOnInit() {}
}
